import { Select } from "antd";
import type { SelectProps } from "antd";
import classNames from "classnames";

import styles from "./index.module.scss";

interface SingleSelectProps extends SelectProps {
  options: { label: any; value: any }[];
  value: any;
  onChange: any;
  placeholder: any;
}

export const SingleForSelect = (props: SingleSelectProps) => {
  const { options, value, onChange, placeholder, ...rest } = props;

  // checked state
  const checked = options.find((option: any) => option.value === value);

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      labelRender={() => {
        return <span>{checked?.label}</span>;
      }}
      {...rest}
    >
      {options.map((option: any) => (
        <Select.Option key={option.value} value={option.value}>
          <div
            className={classNames([
              styles.option,
              checked && checked.value === option.value ? styles.checked : ""
            ])}
          >
            <span className={styles.label}>{option.label}</span>
            <span className={styles.icon}>
              {checked && checked.value === option.value ? SelectedSvg : null}
            </span>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

const SelectedSvg = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.4894 3.45294L6.11985 10.5946C6.01116 10.7165 5.85638 10.7872 5.69311 10.7896C5.52985 10.792 5.37304 10.7259 5.26081 10.6073L1.50781 6.64139L2.3552 5.83949L5.67179 9.34423L11.6187 2.67639L12.4894 3.45294Z'
      fill='#1C70EE'
    />
  </svg>
);
